import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { PencilSquare } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'

const options = [0, 1, 2, 3]

const Cutoff = ({
    label = '',
    value = '',
    onChange = () => {},
    icon = PencilSquare,
    disabled
}) => {
    const { breakpoint, breakpoints } = useViewport()

    const renderOption = (v, k) => {
        let label = 'End of Day'
        if (v === 1) {
            label = 'Day Before'
        }
        if (v > 1) {
            label = `${v} Days Before`
        }
        return (
            <option value={v} key={k}>{label}</option>
        )
    }
    const Icon = icon
    return (
        <Form.Group as={Row} controlId="formHorizontalEmail">
            <Form.Label column sm={12} md={1} lg={2} xl={6}>
                <Icon size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? label : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={6}>
                <Form.Control as='select' value={value} onChange={e => onChange(parseInt(e.target.value))} disabled={disabled}>
                    {options.map(renderOption)}
                </Form.Control>
            </Col>
        </Form.Group>
    )
}

export default Cutoff
